<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual src="/images/sub/sub-visual-pitching-festa.jpg">
                <template #titleContents>
                    <div class="sub-visual__tit-wrap mt-lg-n20px">
                        <h2 class="sub-visual__tit"><span class="font-size-lg-100 font-weight-bold">e</span>커머스피칭페스타 스타트업</h2>
                    </div>
                </template>
            </sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--sm">
            <v-layout column align-center class="text-center">
                <div class="tit-wrap">
                    <h3 class="tit tit--xl">
                        <div data-aos="fade-up">{{ setting?.startup?.title }}</div>
                    </h3>
                </div>

                <v-card color="w-100 grey lighten-5" data-aos="fade-up" data-aos-delay="100">
                    <div class="pa-16px pa-md-24px">
                        <v-row justify="center" class="row--xs">
                            <v-col cols="12" md="auto">
                                <v-select v-model="filter.searchKey" :items="searchKeys" class="v-input--small w-100 w-md-120px" outlined hide-details></v-select>
                            </v-col>
                            <v-col md="auto">
                                <v-text-field v-model="filter.searchValue" class="v-input--small w-100 w-md-400px" outlined hide-details placeholder="검색어를 입력하세요."></v-text-field>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn color="grey" @click="search(false)">검색</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <div class="mt-16px mt-md-24px w-100 hash-wrap" data-aos="fade-up" data-aos-delay="200">
                    <v-btn-toggle v-model="filter.hashTags" group multiple class="v-btn-toggle--primary justify-center">
                        <v-btn v-for="(hashTag, index) in setting?.startup?.hashTags" :key="index" :value="hashTag">#{{ hashTag }}</v-btn>
                    </v-btn-toggle>
                </div>

                <div class="btn-wrap btn-wrap--sm" data-aos="fade-up" data-aos-delay="300">
                    <v-btn  color="grey" dark class="v-btn--width-fixed hash-btn">
                        <span v-if="showText" class="d-flex align-center justify-space-between w-100">더 보기 <v-icon class="font-size-18">mdi-plus</v-icon></span>
                        <span v-else class="d-flex align-center justify-space-between w-100">닫기 <v-icon class="font-size-18">mdi-minus</v-icon></span>
                    </v-btn>
                </div>
            </v-layout>
        </page-section>

        <page-section class="page-section--last  page-section--sm grey lighten-5">
            <div class="tab-wrap" data-aos="fade-right" data-aos-delay="100">
                <u-tabs>
                    <u-tab v-for="(category, index) in categories" :key="index" @click="(filter.category = category), search(true)">
                        {{ category }}
                    </u-tab>
                </u-tabs>
            </div>

            <v-divider class="grey darken-4 mb-20px mb-md-32px" style="border-width: 2px 0 0;" />
            <v-row data-aos="fade-up" data-aos-delay="200">
                <!-- S: 예시 -->
                <v-col v-for="(startup, index) in startups" :key="index" cols="6" md="4" lg="3">
                    <card-board imageBoard :src="startup?.thumb?.src" :to="`/pitching-festa/startup/${startup?._id}`" :chip="startup?.awardName" :title="startup?.name" :text="startup?.description" :view="String(startup?.viewCount)">
                        <template #hash>
                            <v-row class="row--xs">
                                <v-col v-for="(hashTag, index) in startup?.hashTags" :key="index" cols="auto">
                                    <span class="txt txt--xs primary--text">#{{ hashTag }}</span>
                                </v-col>
                            </v-row>
                        </template>
                    </card-board>
                </v-col>
                <!-- S: 반복 v-for -->
                <!-- <v-col cols="6" md="4" lg="3">
                    <card-board imageBoard to="/" chip="대상" title="제목이 들어갑니다." text="내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다." teamName="팀명" view="조회수">
                        <template #hash>
                            <v-row class="row--xs">
                                <v-col cols="auto">
                                    primary 색상으로 변경하기
                                    <span class="txt txt--xs primary--text">#물류</span>
                                </v-col>
                                <v-col cols="auto">
                                    primary 색상으로 변경하기
                                    <span class="txt txt--xs primary--text">#물류</span>
                                </v-col>
                            </v-row>
                        </template>
                    </card-board>
                </v-col> -->
                <!-- E: 반복 v-for -->

                <!-- <v-col cols="6" md="4" lg="3">
                    <card-board to="/" chip="수상구분" title="제목이 들어갑니다." text="내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다. 내용이 들어갑니다." teamName="팀명" view="조회수">
                        <template #hash>
                            <v-row class="row--xs">
                                <v-col cols="auto">
                                    primary 색상으로 변경하기
                                    <span class="txt txt--xs primary--text">#물류</span>
                                </v-col>
                                <v-col cols="auto">
                                    primary 색상으로 변경하기
                                    <span class="txt txt--xs primary--text">#물류</span>
                                </v-col>
                            </v-row>
                        </template>
                    </card-board>
                </v-col> -->
                <!-- <v-col cols="6" md="4" lg="3">
                    <card-board to="/" title="제목이 들어갑니다. 제목이 들어갑니다. 제목이 들어갑니다. 제목이 들어갑니다. 제목이 들어갑니다. 제목이 들어갑니다." teamName="팀명" view="조회수"> </card-board>
                </v-col> -->
                <!-- E: 예시 -->

                <!-- <template v-for="(application, index) in startups">
                    <v-col cols="6" md="4" lg="3" :key="index">
                        <v-card tile flat @click="$router.push(`/pitching-festa/support/` + application._id)">
                            <v-img v-if="application.thumb" cover width="100%" :aspect-ratio="282 / 370" :src="application.thumb.src">
                                <v-overlay absolute opacity="0" class="pt-10px pl-10px justify-start align-start">
                                    <v-chip v-if="application.status == '모집중'" large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">모집중</span></v-chip>
                                    <v-chip v-if="application.status == '모집 종료'" large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">모집 종료</span></v-chip>
                                </v-overlay>
                            </v-img>

                            <div class="pt-18px pt-md-24px">
                                <div class="mb-4px mb-md-8px">
                                    <div class="font-size-18 font-size-md-20 font-weight-extrabold line-height-135 grey--text text--darken-4 text-truncate">{{ application.subject }}</div>
                                </div>
                                <v-row class="row--xs">
                                    <template v-for="(item, index) in application.items">
                                        <v-col cols="12" v-if="item.title == '모집 기간'" :key="index">
                                            <div v-html="item.txt.replace(/\n/g, '<br/>')" class="font-size-16 grey--text text--lighten-1"></div>
                                        </v-col>
                                    </template>
                                </v-row>
                            </div>
                        </v-card>
                    </v-col>
                </template> -->
            </v-row>

            <div class="v-pagination-wrap">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";

const statuses = [
    { name: "전체", value: null },
    { name: "모집중", value: "모집중" },
    { name: "모집 종료", value: "모집 종료" },
];

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";
import CardBoard from "@/components/dumb/card-board.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        UTabs,
        UTab,
        CardBoard,
    },
    data() {
        return {
            statuses,

            filter: {
                category: this.$route.query.category || null,
                searchKey: this.$route.query.searchKey || "name",
                searchValue: this.$route.query.searchValue || null,
                hashTags: [],
            },

            page: +this.$route.query.page || 1,
            pageCount: 0, // 페이징 분할 크기
            limit: 16, // n개 만큼 게시글 가져오기
            summary: { totalCount: 0 },
            startups: [],
            setting: null,
            categories: ["전체"],

            searchKeys: [
                { text: "업체명", value: "name" },
                { text: "내용", value: "description" },
            ],

            showText : true,
        };
    },
    mounted() {
        this.init();
        var hashBtn = document.querySelector(".hash-btn");
        hashBtn.addEventListener("click", this.hashToggle);
    },
    methods: {
        async init() {
            let { setting } = await api.v1.setting.get();
            this.categories.push(...setting.datas.categories);
            this.setting = setting;
            await this.search(false);
        },

        async search(routable = false) {
            // 페이징 or 필터 변경시 라우터 기록 -> 뒤로가기시 이전 라우터로 복귀
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, startups } = await api.v1.kea.startups.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.startups = startups;
        },

        hashToggle() {
        var hash = document.querySelector(".hash-wrap");
        hash.classList.toggle("active");
        this.showText = !this.showText; // Toggle showText value
    },
    },
    watch: {
        "filter.hashTags"() {
            this.search(false);
        },
    },
};
</script>

<style lang="scss" scoped>
.hash-wrap{
    max-height: 80px;
    overflow: hidden;
    transition: 0.15s ease-out;
    &.active{
        max-height: 99999px;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .hash-wrap{
        max-height: 88px;
        overflow: hidden;
        transition: 0.15s ease-out;
        &.active{
            max-height: 99999px;
        }
    }
}
@media (min-width:1200px){
}

</style>